import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { IAcceptanceProgressModel } from "mobx-stores/_models/work-order-po/progress/progress-models";
import { ReactNode } from "react";
import { NumberText } from "share-components/atomics/number-text";
import { EditIconButton } from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import OrderNumberBadge from "./order-number-badge";

type AcceptanceProcessTableProps = {
  standardTitle: string;
  departmentTitle: string;
  progress: IAcceptanceProgressModel;
  note: string;
  onEdit: () => void;
  editAccessPermission: string[];
  leadingCell?: ReactNode;
  orderNumber: number;
};

type ProcessDataRowProps = {
  progress: IAcceptanceProgressModel;
  note: string;
  leadingCell?: ReactNode;
  onEdit: () => void;
  editAccessPermission: string[];
};

const ProcessDataRow = ({
  progress,
  note,
  leadingCell,
  onEdit,
  editAccessPermission,
}: ProcessDataRowProps) => {
  const lossAmount = progress?.lossAmount ?? progress?.lossAmountFECalc ?? 0;
  const lossPercent = progress?.lossPercent ?? progress?.lossPercentFECalc ?? 0;

  return (
    <TableRow>
      <TableCell>
        <Stack direction="row" spacing={1} alignItems="center">
          {leadingCell}
          <EditIconButton
            accessPermission={editAccessPermission}
            onClick={onEdit}
          ></EditIconButton>
        </Stack>
      </TableCell>
      <TableCell>{dateTimeDisplay(progress?.date) || ""}</TableCell>
      <TableCell>
        <NumberText value={progress?.printPaperAmount || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.amount || 0}></NumberText>
      </TableCell>
      <TableCell>{progress?.equipment || ""}</TableCell>
      <TableCell>{progress?.operator || ""}</TableCell>
      <TableCell>{progress?.inspector || ""}</TableCell>
      <TableCell>{dateTimeDisplay(progress?.completedDate) || ""}</TableCell>
      <TableCell>
        <NumberText value={progress?.firstGradeAmountPaper || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.secondGradeAmountPaper || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.rejectedAmountPaper || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.firstGradeAmountPcs || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.secondGradeAmountPcs || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.rejectedAmountPcs || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText
          value={progress?.printPaperCompletedAmount || 0}
        ></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={progress?.completedAmount || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={lossAmount}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={lossPercent}></NumberText>
      </TableCell>
      <TableCell>{note}</TableCell>
    </TableRow>
  );
};

export const AcceptanceProcessTable = ({
  standardTitle,
  departmentTitle,
  progress,
  note,
  onEdit,
  editAccessPermission,
  leadingCell,
  orderNumber,
}: AcceptanceProcessTableProps) => {
  return (
    <OrderNumberBadge orderNumber={orderNumber}>
      <XTablePagination hidePagination>
        <TableHead>
          <TableRow>
            <TableCell align="center" rowSpan={2}>
              {standardTitle}
            </TableCell>
            <TableCell align="center" colSpan={17}>
              {departmentTitle}
            </TableCell>
            <TableCell align="center" rowSpan={2}>
              Ghi Chú Sản Xuất
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Ngày S/X</TableCell>
            <TableCell>Số Lượng S/X (tờ)</TableCell>
            <TableCell>Số Lượng S/X (pcs)</TableCell>
            <TableCell>Thiết Bị S/X</TableCell>
            <TableCell>Người S/X</TableCell>
            <TableCell>Người Kiểm QT</TableCell>
            <TableCell>Ngày H/T</TableCell>
            <TableCell>Hàng Loại 1 (tờ)</TableCell>
            <TableCell>Hàng Loại 2 (tờ)</TableCell>
            <TableCell>Hư 100% (tờ)</TableCell>
            <TableCell>Hàng Loại 1 (pcs)</TableCell>
            <TableCell>Hàng Loại 2 (pcs)</TableCell>
            <TableCell>Hư 100% (pcs)</TableCell>
            <TableCell>Số Lượng H/T (tờ)</TableCell>
            <TableCell>Số Lượng H/T (pcs)</TableCell>
            <TableCell>Hao Hụt</TableCell>
            <TableCell>Tỉ Lệ %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ProcessDataRow
            progress={progress}
            note={note}
            leadingCell={leadingCell}
            onEdit={onEdit}
            editAccessPermission={editAccessPermission}
          ></ProcessDataRow>
        </TableBody>
      </XTablePagination>
    </OrderNumberBadge>
  );
};
